import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "portalProps", "portalClassName", "theme", "portalRef", "children", "onClose", "ignoredClickOutsideRefs", "closeOptions"];
import React, { memo } from 'react';
import { cnBem, forwardRefWithMotion } from '@carnica/utils';
import { AnimatePresence, motion } from 'framer-motion';
import styles from "./styles.pcss";
import { ThemedPortal } from '..';
import { BottomSheetWindow } from "./BottomSheetWindow";
var cnBottomSheet = cnBem('bottom-sheet', styles);
var BottomSheetRender = forwardRefWithMotion(function (props, ref) {
  var isOpen = props.isOpen,
    portalProps = props.portalProps,
    portalClassName = props.portalClassName,
    theme = props.theme,
    portalRef = props.portalRef,
    children = props.children,
    onClose = props.onClose,
    _props$ignoredClickOu = props.ignoredClickOutsideRefs,
    ignoredClickOutsideRefs = _props$ignoredClickOu === void 0 ? [] : _props$ignoredClickOu,
    _props$closeOptions = props.closeOptions,
    closeOptions = _props$closeOptions === void 0 ? {
      button: true,
      overlay: true
    } : _props$closeOptions,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    custom: isOpen,
    initial: false,
    mode: "wait",
    onExitComplete: function onExitComplete() {
      return null;
    },
    "data-t-id": "modules-BottomSheet"
  }, isOpen && /*#__PURE__*/React.createElement(ThemedPortal, _extends({}, portalProps || {}, {
    "aria-modal": true,
    className: cnBottomSheet(null, [portalClassName]),
    motion: true,
    ref: portalRef,
    role: "dialog",
    theme: theme
  }), /*#__PURE__*/React.createElement(motion.div, {
    animate: {
      opacity: 1
    },
    "aria-hidden": "true",
    className: cnBottomSheet('overlay'),
    exit: {
      opacity: 0
    },
    initial: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement(BottomSheetWindow, _extends({}, otherProps, {
    closeOptions: closeOptions,
    ignoredClickOutsideRefs: ignoredClickOutsideRefs,
    onClose: onClose,
    ref: ref,
    "data-t-id": "modules-BottomSheet"
  }), children)));
});
export var BottomSheet = /*#__PURE__*/memo(BottomSheetRender);